<template>
  <div class="wrapper">
    <header class="header">
      <a href="#" class="close" @click.prevent="close">
        <i-icon name="cancel" />
      </a>
      <h3 class="heading">{{ __("Filters") }}</h3>
    </header>
    <main class="main">
      <div class="status p-mb-4">
        <p-vue-dropdown
          :options="strTblStatusOption"
          :optionLabel="'Name'"
          :placeholder="__('Status')"
          v-model="strTblStatus"
          class="dropdown"
          scrollHeight="300px"
        >
          <template #value="{ placeholder }">
            <div class="inner p-d-flex p-jc-between">
              <span>{{ placeholder }}</span>
              <span class="icon">
                <i-icon name="arrow" />
              </span>
            </div>
          </template>
        </p-vue-dropdown>
        <p-vue-button
          icon="pi pi-save"
          class="p-button-rounded p-button-success p-button-outlined"
          @click="saveDefault"
        />
      </div>
      <p-vue-dropdown
        :options="orderOptions"
        :optionLabel="'label'"
        :placeholder="__('sort')"
        v-model="order"
        scrollHeight="310px"
        class="dropdown p-mb-4"
        @change="sortServiceCalls"
      >
        <template #value="{ placeholder }">
          <div class="inner p-d-flex p-jc-between">
            <span>{{ placeholder }}</span>
            <span class="icon">
              <i-icon name="arrow" />
            </span>
          </div>
        </template>
      </p-vue-dropdown>
      <p-vue-dropdown
        :options="reportTypesOptions"
        :optionLabel="'ReportType'"
        :placeholder="__('Domain')"
        v-model="reportType"
        class="dropdown p-mb-4"
        scrollHeight="300px"
      >
        <template #value="{ placeholder }">
          <div class="inner p-d-flex p-jc-between">
            <span>{{ placeholder }}</span>
            <span class="icon">
              <i-icon name="arrow" />
            </span>
          </div>
        </template>
      </p-vue-dropdown>
      <p-vue-dropdown
        :options="workersOptions"
        :optionLabel="'WorkerName'"
        :placeholder="__('User')"
        v-model="worker"
        class="dropdown p-mb-4"
        scrollHeight="300px"
      >
        <template #value="{ placeholder }">
          <div class="inner p-d-flex p-jc-between">
            <span>{{ placeholder }}</span>
            <span class="icon">
              <i-icon name="arrow" />
            </span>
          </div>
        </template>
      </p-vue-dropdown>
      <p-vue-dropdown
        :options="priorityOptions"
        :optionLabel="'ReportPriority'"
        :placeholder="__('Priority')"
        v-model="priority"
        class="dropdown p-mb-4"
        scrollHeight="300px"
      >
        <template #value="{ placeholder }">
          <div class="inner p-d-flex p-jc-between">
            <span>{{ placeholder }}</span>
            <span class="icon">
              <i-icon name="arrow" />
            </span>
          </div>
        </template>
      </p-vue-dropdown>
      <div class="p-mb-4">
        <i-customized-calendar
          v-model="openingDate"
          :placeholder="__('From date')"
        />
      </div>
      <div class="p-mb-4 p-d-flex p-flex-column">
        <span>{{ __("Show Rules") }}</span>
        <i-override-select-button
          v-model="showRules"
          :options="showRulesOption"
          optionLabel="label"
          @change="showRulesChange"
        ></i-override-select-button>
      </div>
      <div class="p-mb-2 p-d-flex p-flex-column" v-if="enableHomeSvcCalls != 0">
        <span>{{ __("Call type") }}</span>
        <i-override-select-button
          v-model="showHomeSvcCalls"
          :options="showHomeSvcCallsOption"
          optionLabel="label"
        ></i-override-select-button>
      </div>
    </main>
    <div class="actions p-fluid">
      <p-vue-button
        class="p-button p-button-outlined p-button-rounded p-button-success"
        @click="filter"
      >
        <span class="p-button-text">{{ __("Filter") }}</span>
      </p-vue-button>
    </div>
  </div>
</template>

<script>
import { __ } from "@/plugins/i18n/";
import { mapState } from "vuex";
import { callProc, apiParam, apiPType } from "@/services/APointAPI";
import { errorReceived, showSuccessOrFailedModal } from "@/services/apointUtil";
export default {
  props: {
    close: {
      type: Function,
      default: () => false,
    },
    filters: Object,
  },
  emits: ["filter", "sort", "changeFiltersData"],
  data() {
    return {
      order: null,
      orderOptions: [
        {
          label: __("Opening date") + " - " + __("ascending order"),
          value: "OpenDate",
        },
        {
          label: __("Opening date") + " - " + __("descending order"),
          value: "OpenDate DESC",
        },
        {
          label: __("Closing date") + " - " + __("ascending order"),
          value: "ClosingDate",
        },
        {
          label: __("Closing date") + " - " + __("descending order"),
          value: "ClosingDate DESC",
        },
        {
          label: __("Problem ID") + " - " + __("ascending order"),
          value: "PID",
        },
        {
          label: __("Problem ID") + " - " + __("descending order"),
          value: "PID DESC",
        },
        {
          label: __("Priority - OpenDate") + " - " + __("descending order"),
          value: "Priority OpenDate DESC",
        },
        {
          label: __("Due Date") + " - " + __("ascending order"),
          value: "DueDate",
        },
        {
          label: __("Due Date") + " - " + __("descending order"),
          value: "DueDate DESC",
        },
        {
          label: __("Date") + " " + __("Last update") + " - " + __("ascending order"),
          value: "LastDateUpdate",
        },
        {
          label: __("Date") + " " + __("Last update") + " - " + __("descending order"),
          value: "LastDateUpdate DESC",
        },
      ],
      strTblStatus: null,
      showRules: false,
      showRulesOption: {},
      showHomeSvcCalls: false,
      showHomeSvcCallsOption: {},
      strTblStatusOption: null,
      defaultTypeFilter: null,
      defaultStatus: null,
      enableHomeSvcCalls: false,
      reportTypesOptions: {},
      reportType: null,
      openingDate: null,
      worker: null,
      workersOptions: null,
      priority: null,
      priorityOptions: null,
    };
  },
  mounted() {
    this.defaultStatus = this.filters.defaultStatus;
    this.defaultTypeFilter = this.filters.defaultTypeFilter;
    this.strTblStatusOption = this.filters.strTblStatusOption;
    this.enableHomeSvcCalls = this.filters.enableHomeSvcCalls;
    this.showHomeSvcCallsOption = this.filters.showHomeSvcCallsOption;
    this.reportTypesOptions = this.filters.reportTypesOptions;
    this.showRulesOption = this.filters.showRulesOption;
    this.showHomeSvcCalls = this.filters.showHomeSvcCalls;
    this.showRules = this.filters.showRulesOption.find(
      (f) => f.value == this.showRulesServiceCall
    );
    this.order = this.orderOptions.find((f) => f.value == this.filters.order);
    this.openingDate = this.filters.openingDate;
    this.worker = this.filters.worker;
    this.workersOptions = this.filters.workersOptions;
    this.priorityOptions = this.filters.priorityOptions;
    this.priority = this.filters.priority;
    // this.reportType = this.reportTypesOptions[0];
    this.setStrTblStatusByStatusAndTypeFilter();
  },
  methods: {
    showRulesChange() {
      this.$store.commit("api/setSessionData", {
        showRulesServiceCall: this.showRules.value,
      });
      this.filter();
    },
    getStatusAndTypeFilter() {
      let status, typeFilter;
      if (this.strTblStatus) {
        switch (this.strTblStatus.ID) {
          case 1: // פתוחות - רק שלי
            status = 1;
            typeFilter = 0;
            break;
          case 2: // פתוחות - של כולם
            status = 1;
            typeFilter = 1;
            break;
          case 3: // סגורות - רק שלי
            status = 2;
            typeFilter = 0;
            break;
          case 4: // סגורות - של כולם
            status = 2;
            typeFilter = 1;
            break;
          case 5: // הכל - רק שלי
            status = 0;
            typeFilter = 0;
            break;
          case 6: // הכל - של כולם
            status = 0;
            typeFilter = 1;
            break;
        }
      } else {
        status = this.defaultStatus;
        typeFilter = this.defaultTypeFilter;
      }
      // console.log(status, typeFilter);
      return { status, typeFilter };
    },
    setStrTblStatusByStatusAndTypeFilter() {
      let id, status, typeFilter;
      if (
        this.filters.filterStatus >= 0 &&
        this.filters.filterTypeFilter >= 0
      ) {
        status = this.filters.filterStatus;
        typeFilter = this.filters.filterTypeFilter;
      } else {
        status = this.defaultStatus;
        typeFilter = this.defaultTypeFilter;
      }
      if (status == 1 && typeFilter == 0) id = 1;
      //פתוחות - רק שלי
      else if (status == 1 && typeFilter == 1) id = 2;
      //פתוחות - של כולם
      else if (status == 2 && typeFilter == 0) id = 3;
      //סגורות - רק שלי
      else if (status == 2 && typeFilter == 1) id = 4;
      //סגורות - של כולם
      else if (status == 0 && typeFilter == 0) id = 5;
      //הכל - רק שלי
      else if (status == 0 && typeFilter == 1) id = 6; //הכל - של כולם
      this.strTblStatus = this.strTblStatusOption.find((f) => f.ID == id);
    },
    sortServiceCalls() {
      this.$emit("sort", this.order.value);
      this.close();
    },
    filter() {
      let { status, typeFilter } = this.getStatusAndTypeFilter();
      this.$emit(
        "filter",
        status,
        typeFilter,
        this.showRules.value,
        this.showHomeSvcCalls.value,
        this.reportType?.Num,
        this.openingDate,
        this.worker?.Num,
        this.priority?.Num
      );
      this.close();
    },
    saveDefault() {
      let { status, typeFilter } = this.getStatusAndTypeFilter();
      this.$store.dispatch("doLoading", true);
      let procParams = [
        apiParam("UserId", this.userNum, apiPType.Int),
        apiParam("status", status, apiPType.Int),
        apiParam("typeFilter", typeFilter, apiPType.Int),
      ];
      callProc("WorkerApp_UpdateWorkerDefaults", procParams)
        .then((result) => {
          result = JSON.parse(result);
          // console.log(result);
          if (result.procReturnValue == 0) {
            showSuccessOrFailedModal(__("Data saved successfully!"));
            setTimeout(() => {
              this.$emit("changeFiltersData", {
                defaultStatus: status,
                defaultTypeFilter: typeFilter,
              });
            }, 1000);
          } else {
            showSuccessOrFailedModal(__("An error occurred"), false);
          }

          this.$store.dispatch("doLoading", false);
        })
        .catch(() => {
          errorReceived("WorkerApp_UpdateWorkerDefaults");
        });
    },
  },
  computed: {
    ...mapState({
      showRulesServiceCall: (state) => state.api.showRulesServiceCall,
      userNum: (state) => state.api.workerID,
    }),
  },
};
</script>

<style scoped>
.wrapper {
  display: flex;
  flex-direction: column;
  min-height: 95vh;
  max-height: 100vh;
}

.header {
  top: 0;
  z-index: 2;
  position: sticky;
  position: -webkit-sticky;
  background-color: white;
  padding: 20px;
}

.close {
  position: absolute;
  left: calc(100% + 30px);
  color: white;
}

.close .svg {
  width: 21px;
  height: 21px;
}

.heading {
  margin: 0;
  line-height: 1;
  font-size: 26px;
  font-weight: normal;
  color: var(--color-primary);
}

.main {
  flex: 1;
  display: flex;
  flex-direction: column;
  padding: 0 20px;
  overflow-y: auto;
  -webkit-overflow-scrolling: touch;
}

.actions {
  padding: 20px;
}

.actions:deep(button) {
  margin-bottom: 20px;
}

.icon:deep(.svg) {
  color: var(--color-success);
  width: 15px;
  height: 15px;
}

:deep(.p-selectbutton .p-highlight) {
  background-color: var(--color-success);
  border-color: var(--color-success);
}

:deep(.p-selectbutton .p-highlight:hover) {
  background-color: var(--color-success);
  border-color: var(--color-success);
}

:deep(.p-override-select-button) {
  width: 100%;
  margin-top: 10px;
}

:deep(.p-selectbutton.p-buttonset.p-component) {
  width: 100%;
  display: grid;
  grid-template-columns: 50% 50%;
}

:deep(.p-override-select-button .p-buttonset .p-button:first-of-type) {
  border-top-left-radius: 4px;
  border-bottom-left-radius: 4px;
}

:deep(.p-override-select-button .p-buttonset .p-button:last-of-type) {
  border-top-right-radius: 4px;
  border-bottom-right-radius: 4px;
}

.status {
  display: grid;
  grid-template-columns: 75% 20%;
  justify-content: space-between;
  align-items: center;
}
</style>
